"use client";
import { Button } from "@/components/ui/button";
import Image from "next/image";
import Link from "next/link";
import * as images from "@/components/images/Images";
import { useEffect } from "react";
import { Typography } from "@/components/ui/typography";
import { ROUTES } from "@/constants";
import Picture from "@/components/ui/picture";

type HomeProps = {
  content: {
    heroTitle?: string;
    heroDescriptions?: string;
  };
};

export default function HeroBlock({ content }: HomeProps) {
  return (
    <section className="overflow-hidden section pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)]">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 pt-6 pb-6 gap-8 md:pt-30 lg:text-start lg:grid-cols-[minmax(0,0.46fr)_minmax(0,0.54fr)] pb-[38] md:pb-[7.75rem]">
          <div className="flex flex-col gap-8 w-full lg:max-w-[540px]">
            <div className="grid grid-cols-1 gap-4 md:gap-8">
              <Typography variant="headingMain" className="w-full" asChild>
                <h1>{content.heroTitle}</h1>
              </Typography>
              <Typography variant="bodyLg" asChild>
                <p>{content.heroDescriptions}</p>
              </Typography>
            </div>
            <div className="grid grid-cols-1 gap-4 md:gap-8">
              <div className="grid grid-cols-1 gap-4 sm:flex flex-wrap">
                <Button
                  asChild
                  variant="primary"
                  className="sm:w-[247px] h-[48px]"
                >
                  <Link href={ROUTES.startOrder} className="!text-base w-full">
                    Start order
                  </Link>
                </Button>
                <Button
                  asChild
                  variant="primary-outline"
                  className="h-[48px] sm:w-[141px]"
                >
                  <Link href={ROUTES.getQuote} className="!text-base w-full">
                    Get  a quote
                  </Link>
                </Button>
              </div>
            </div>
          </div>
          <div className="flex items-start lg:justify-end lg:-mt-[7%] lg:-mr-[11%]">
            {/* <Image
              alt="Languex Hero Illustration"
              src={images.heroHome}
              width={1333}
              height={1032}
              className="flex-auto min-w-0"
              quality={100}
            /> */}
            <Picture
              desktop={{
                src: images.heroHome.src,
              }}
              mobile={{
                src: images.heroHomeMobile.src,
              }}
              priority
              width={1333}
              height={1032}
              quality={80}
              className="flex"
              classNameImage="flex-auto min-w-0"
              imageProps={{
                sizes: "(max-width: 479px) 364px, 1333px",
                fetchPriority: "high",
              }}
              alt="Languex Hero Illustration"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
